"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navBarWrapperStyle = {
    root: {
        backgroundColor: '#677f92',
        padding: '2px 10px',
        minHeight: '52px'
    }
};
exports.iconButtonStyle = {
    icon: {
        color: 'white'
    },
    root: {
        width: '48px',
        height: '48px',
        transition: 'background 0.4s'
    },
    rootHovered: {
        background: 'rgba(255, 255, 255, 0.15)'
    }
};
